// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.Emailing.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

import React from 'react';

import connect from 'share/enhancers/Izenda.Connect';
import Panel from 'share/components/controls/Izenda.Panel';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import RightPanelContent from './Izenda.RightPanelContent';
import Header from './Izenda.Header';

const Emailing = connect()(props => {
  const { model, localization } = props;
  const header = {
    component: Header,
    headerName: localization.getText('COMMON_LABEL_EMAILING'),
    model: props.model
  };
  const className = 'grid-small-column u_borderRight u-bgWhite';
  return (
    <Panel
      className='u_fullHeight u_noMarginAll u_noPaddingAll u_noBorder'
      header={header}
      collapsible
      expanedOption={model.collapseAll}
    >
      <GridLayout>
        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <div>
                <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                <span>{localization.getText('COMMON_LABEL_DELIVERY_METHOD')}</span>
              </div>
            </GridLayout.Col>
            <RightPanelContent isParent />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>{localization.getText('COMMON_LABEL_LINK')}</span>
            </GridLayout.Col>
            <RightPanelContent keysPath='emailing.deliveryMethod.link' model={model} />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>{localization.getText('COMMON_LABEL_EMBEDDED_HTML')}</span>
            </GridLayout.Col>
            <RightPanelContent keysPath='emailing.deliveryMethod.embeddedHTML' model={model} />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>{localization.getText('COMMON_LABEL_ATTACHMENT')}</span>
            </GridLayout.Col>
            <RightPanelContent keysPath='emailing.deliveryMethod.attachment' model={model} />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <div>
                <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                <span>{localization.getText('COMMON_LABEL_ATTACHMENT_TYPE')}</span>
              </div>
            </GridLayout.Col>
            <RightPanelContent isParent />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>Word</span>
            </GridLayout.Col>
            <RightPanelContent keysPath='emailing.attachmentType.word' model={model} />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>Excel</span>
            </GridLayout.Col>
            <RightPanelContent keysPath='emailing.attachmentType.excel' model={model} />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>PDF</span>
            </GridLayout.Col>
            <RightPanelContent keysPath='emailing.attachmentType.pdf' model={model} />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>CSV</span>
            </GridLayout.Col>
            <RightPanelContent keysPath='emailing.attachmentType.csv' model={model} />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>XML</span>
            </GridLayout.Col>
            <RightPanelContent keysPath='emailing.attachmentType.xml' model={model} />
          </GridLayout.Col>
        </GridLayout.Row>

        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>JSON</span>
            </GridLayout.Col>
            <RightPanelContent keysPath='emailing.attachmentType.json' model={model} />
          </GridLayout.Col>
        </GridLayout.Row>
        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className={className}>
              <span className='izenda-Permission-FirstChild'>
                {localization.getText('PERMISSION_LABEL_DEFINITION')}
              </span>
            </GridLayout.Col>
            <RightPanelContent keysPath='emailing.attachmentType.definition' model={model} />
          </GridLayout.Col>
        </GridLayout.Row>
      </GridLayout>
    </Panel>
  );
});

export default Emailing;



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/RoleDetail/PermissionSummary/Izenda.Emailing.js